import React from 'react'
import aiGalleries from '../../Assets/Images/aiGalleries.png'
import aiMagicIcon from '../../Assets/Images/aiMagicIcon.svg'

function Galleries() {
    return (
        <div className='w-full h-full xl:px-[8.33%] mb-[80px] xl:mb-[120px]'>
            <div className='flex flex-col-reverse xl:grid xl:grid-cols-6'>
                <div className='px-[5.26%] xl:px-0 xl:col-span-4 flex flex-col gap-[40px] xl:gap-[75px] justify-center'>
                    <div>
                        <p className='mb-[10px] xl:mb-[8px] font-medium text-[16px] xl:text-[18px] leading-[22px] tracking-[-0.32px] xl:tracking-[-0.36px] text-[#9747FF]'>Ai Powered Galleries</p>
                        <p className='xl:max-w-[357px] mb-[16px] font-semibold text-[24px] xl:text-[32px] tracking-[-0.48px] xl:tracking-[-0.64px] text-[#161616]'>Discover the Magic of AI-powered Galleries</p>
                        <p className='xl:max-w-[369px] text-[16px] leading-[22px] tracking-[-0.32px] text-[#161616]'>Deliver your guests’ personal photos with the best in world-class Face Recognition technology.</p>
                    </div>
                    <div className='flex flex-col gap-[40px]'>
                        <div className='flex gap-[12px] items-center'>
                            <img src={aiMagicIcon} alt="" />
                            <p className='xl:max-w-[428px] font-medium text-[13px] leading-[18px] tracking-[-0.26px] text-[#161616]'>Guests can ‘pre-register’ their faces via a QR code to and automatically receive their pictures from the event via Whatsapp link.</p>
                        </div>
                        <div className='flex gap-[12px] items-center'>
                            <img src={aiMagicIcon} alt="" />
                            <p className='xl:max-w-[428px] font-medium text-[13px] leading-[18px] tracking-[-0.26px] text-[#161616]'>Lets your guests find and download their high-resolution pictures by simply clicking a selfie.</p>
                        </div>
                        <div className='flex gap-[12px] items-center'>
                            <img src={aiMagicIcon} alt="" />
                            <p className='xl:max-w-[428px] font-medium text-[13px] leading-[18px] tracking-[-0.26px] text-[#161616]'>Smartly identify and group photos of people to help you visually find photos quickly.</p>
                        </div>
                    </div>
                </div>
                <div className='xl:col-span-2 px-[13.85%] sm:px-[5.26%] xl:px-0 mb-[40px] xl:mb-0 flex justify-center sm:justify-start xl:justify-center'>
                    <img src={aiGalleries} alt="" />
                </div>
            </div>
        </div>
    )
}

export default Galleries